var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreentick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frame_1017",
    "data-name": "Frame 1017",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1017_Background_Mask_",
    "data-name": "Frame 1017 (Background/Mask)",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#45b26b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_File_Upload_Line",
    "data-name": "icons/File Upload/Line",
    transform: "translate(17 19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M12.293.293a1,1,0,0,1,1.5,1.32l-.083.094-8,8a1,1,0,0,1-1.32.083l-.094-.083-4-4a1,1,0,0,1,1.32-1.5l.094.083L5,7.585Z",
    fill: "#fcfcfd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/greentick.59d2be28017f40f32046024bc1ef04ac.svg";
export { ForwardRef as ReactComponent };